import { serverConfig } from '@/config/server.config'
import { RegistrationStatus } from '@/types/'
import type { IsRegisteredResponse } from '@/types/authentication'

export async function checkRegistrationStatus(
  encryptedUrl: string,
): Promise<IsRegisteredResponse> {
  const response = await fetch(
    `${serverConfig.digitalCommunicationsApiUrl}/authentication/isRegistered?encryptedUrl=${encodeURIComponent(encryptedUrl)}`,
  )
  if (!response.ok) {
    return {
      data: null,
      registrationStatus: RegistrationStatus.Unknown,
      isSuccess: false,
      needsToLogin: true,
    }
  }
  return response.json()
}
